/* @flow */
import * as React from 'react';
import { withTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import ActionButton from '../ActionButton';
import Checkbox from '../Checkbox';
import Icon from '../Icon';
import Table from '../Table';
import playArrowImg from '../../assets/images/play-arrow-white.svg';

import type { SortingParams, TrackSortingField, Translate } from '../../types';

type Props = {
  showActionButtons?: boolean,
  sorting?: SortingParams<TrackSortingField>,
  showCheckbox?: boolean,
  isSelectable?: boolean,
  isSelected?: boolean,
  isSelectedIndeterminate?: boolean,
  isPlayerVisible?: boolean,
  onPlayClick?: () => mixed,
  onHeaderClick?: (field: TrackSortingField) => mixed,
  onCheckboxClick?: () => mixed,
  isLoading?: boolean,
  isDetailsExpanded?: boolean,
  onDetailsExpand?: () => mixed,
  hasUsage?: boolean,
  showTrackNumber?: boolean,
  showPurchaseDate?: boolean,
  showSentToCartDate?: boolean,
  actionButtons: React.Node,
  rightElement?: React.Node,
  adjustForScrollbar?: boolean,
  t: Translate,
};

const sortingIcon = (field: TrackSortingField, sorting?: SortingParams<TrackSortingField>) => {
  if (sorting && sorting.field === field) {
    const iconName = sorting.order === 'asc' ? 'chevron_up' : 'chevron_down';
    return <Icon name={iconName} />;
  } else {
    return null;
  }
};

class TrackListHeader extends React.PureComponent<Props, void> {
  render() {
    const {
      sorting,
      showCheckbox,
      isSelectable,
      isSelected,
      isSelectedIndeterminate = false,
      isPlayerVisible = false,
      onPlayClick,
      hasUsage = false,
      onHeaderClick,
      showActionButtons,
      onCheckboxClick,
      actionButtons,
      isDetailsExpanded = false,
      onDetailsExpand,
      showTrackNumber,
      showPurchaseDate = false,
      showSentToCartDate = false,
      adjustForScrollbar = false,
      rightElement,
      t,
    } = this.props;
    const scrollbarStyle = adjustForScrollbar ? styles.adjustForScrollbar : undefined;
    return (
      <Table.Row isHeader={true} className={scrollbarStyle}>
        {isSelectable && (
          <Table.HeaderCell>
            {showCheckbox ? (
              <Checkbox
                onClick={onCheckboxClick}
                small={true}
                checked={isSelected || isSelectedIndeterminate}
                isIndeterminate={isSelectedIndeterminate}
              />
            ) : null}
          </Table.HeaderCell>
        )}
        <Table.HeaderCell
          textAlign={'center'}
          onClick={() => (onHeaderClick ? onHeaderClick('media') : undefined)}
        >
          <div className={styles.sortable}>{'A'}</div>
          {sortingIcon('media', sorting)}
        </Table.HeaderCell>
        <Table.HeaderCell onClick={isPlayerVisible ? onPlayClick : undefined}>
          {isPlayerVisible && (
            <React.Fragment>
              <div className={styles.playerBackground} />
              <img src={playArrowImg} className={styles.playerArrowOverlay} alt={t('PLAY')} />
            </React.Fragment>
          )}
        </Table.HeaderCell>
        {showTrackNumber && <Table.HeaderCell>#</Table.HeaderCell>}
        <Table.HeaderCell onClick={() => (onHeaderClick ? onHeaderClick('title') : undefined)}>
          <div className={styles.sortable}>{t('TITLE')}</div>
          {sortingIcon('title', sorting)}
        </Table.HeaderCell>
        <Table.HeaderCell onClick={() => (onHeaderClick ? onHeaderClick('performers') : undefined)}>
          <div className={styles.sortable}>{t('PERFORMERS')}</div>
          {sortingIcon('performers', sorting)}
        </Table.HeaderCell>
        <Table.HeaderCell onClick={() => (onHeaderClick ? onHeaderClick('authors') : undefined)}>
          <div className={styles.sortable}>{t('AUTHORS')}</div>
          {sortingIcon('authors', sorting)}
        </Table.HeaderCell>
        {hasUsage && <Table.HeaderCell>{t('AREA')}</Table.HeaderCell>}
        {hasUsage && <Table.HeaderCell>{t('PRODUCTION')}</Table.HeaderCell>}
        {hasUsage && <Table.HeaderCell>{t('EPISODE')}</Table.HeaderCell>}
        {hasUsage && <Table.HeaderCell>{t('USAGE_TYPE')}</Table.HeaderCell>}
        {hasUsage && <Table.HeaderCell>{t('USAGE')}</Table.HeaderCell>}
        <Table.HeaderCell>{t('DURATION')}</Table.HeaderCell>
        <Table.HeaderCell>{t('PRICE')}</Table.HeaderCell>
        {!!showPurchaseDate && <Table.HeaderCell>{t('PURCHASE_DATE')}</Table.HeaderCell>}
        {!!showSentToCartDate && <Table.HeaderCell>{t('SENT_TO_CART_DATE')}</Table.HeaderCell>}
        <Table.HeaderCell>
          <div className={styles.actions}>
            {showActionButtons && actionButtons}
            {showActionButtons && rightElement}
            {showActionButtons && onDetailsExpand && (
              <ActionButton
                iconName={isDetailsExpanded ? 'expand_less' : 'expand_more'}
                onClick={onDetailsExpand}
                tooltip={isDetailsExpanded ? t('COLLAPSE') : t('EXPAND')}
              />
            )}
          </div>
        </Table.HeaderCell>
      </Table.Row>
    );
  }
}

export default withTranslation()(TrackListHeader);
